require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./v-ultras-violencia-y-racismo-la-otra-cara-del-mundial-de-rusia.json") })
        }
      }, "path---v-ultras-violencia-y-racismo-la-otra-cara-del-mundial-de-rusia");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---v-ultras-violencia-y-racismo-la-otra-cara-del-mundial-de-rusia!./.cache/json/v-ultras-violencia-y-racismo-la-otra-cara-del-mundial-de-rusia.json
// module id = 450
// module chunks = 231608221292675